import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
  DataTable,
  Collapsible,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import moment from "moment";

const ReportBookingDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [result, setResult] = useState("");
  const [ts, setTs] = useState("");

  useEffect(() => {
    fetchData();
  }, [ts]);
  async function fetchData() {
    let responseItem = "";

    try {
      responseItem = await axios.get(`/transactions/${id}`);
      setResult(responseItem.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Amount has been added successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const [open, setOpen] = useState(false);
  const handleToggle = useCallback(() => setOpen((open) => !open), []);
  const switchPayment = (param) => {
    switch (param) {
      case "wallet":
        return `Wallet`;
      case "card":
        return `Card`;
      case "offline_card":
        return `Offline Card`;
      case "cash":
        return `Cash`;
      case "credits":
        return `Credits`;
      case "subscription":
        return `Subscription`;
      case "bank_transfer":
        return `Bank Transfer`;
      case "other":
        return `Other`;
      default:
        return "-";
    }
  };
  return result ? (
    <Page
      narrowWidth
      backAction={{ onAction: () => navigate("/admin/bookings") }}
      title={`${
        result?.user && result?.user?.first_name ? result?.user?.first_name : ""
      } ${
        result?.caususerer && result?.user?.last_name
          ? result?.user?.last_name
          : ""
      }`}
    >
      <FormLayout>
        <Card>
          <FormLayout>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>ID</b>
                <br />
                {result?.id}
              </Text>
              <Text breakWord>
                <b>Sale ID</b>
                <br />
                {result?.sales_reference ? result?.sales_reference : "-"}
              </Text>
              <Text breakWord>
                <b>User ID</b>
                <br />
                {result?.user?.id}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>First Name</b>
                <br />
                {result?.user && result?.user?.first_name
                  ? result?.user?.first_name
                  : "-"}
              </Text>
              <Text breakWord>
                <b>Last Name</b>
                <br />
                {result?.user && result?.user?.last_name
                  ? result?.user?.last_name
                  : "-"}
              </Text>
              <Text breakWord>
                <b>Email</b>
                <br />
                {result?.user && result?.user?.email
                  ? result?.user?.email
                  : "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Date</b>
                <br />
                {result?.created_at
                  ? moment(result?.created_at).format("YYYY-MM-DD HH:mm:ss")
                  : "-"}
              </Text>
              <Text breakWord>
                <b>Amount</b>
                <br />
                {result?.amount !== null ? result?.amount : "-"}
              </Text>
              <Text breakWord>
                <b>Type</b>
                <br />
                {result?.type ? result?.type : "-"}
              </Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Class</b>
                <br />
                {result?.item_name ? result?.item_name : "-"}
              </Text>
              <Text breakWord>
                <b>Location</b>
                <br />
                {result?.session && result?.session.location
                  ? result?.session.location
                  : "-"}
              </Text>
              <Text breakWord>
                <b>Payment Method</b>
                <br />
                {result?.payment_type
                  ? switchPayment(result.payment_type)
                  : "-"}
              </Text>
            </FormLayout.Group>
          </FormLayout>
        </Card>
      </FormLayout>
      {/* <PageActions
        secondaryActions={
          <Button
            variant="primary"
            loading={isSaving}
            tone="critical"
            onClick={() => {
              setIsSaving(true);
              axios
                .delete(`/app/users/${id}`)
                .then((result) => {
                  navigate("/admin/users");
                })
                .catch((err) => console.log(err));
            }}
          >
            Delete
          </Button>
        }
      /> */}
      {toastMarkup}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default ReportBookingDetails;
